import { useLoadContacts } from '@entities/contacts';
import { useUser } from '@shared/hooks/index.ts';
import { PersonalClient } from './client';
import { PersonalCoach } from './coach';

export const Personal = () => {
  useLoadContacts();
  const { user } = useUser();

  if (user?.is_coach) return <PersonalCoach />;
  return <PersonalClient />;
};
